export type ArticleData = {
  slug: string;
  title: string;
  description: string;
  date: string;
  readTime: string;
  imageSeq: string;
  imageQuery: string;
  sections: ArticleSection[];
  keywords: string;
};

export type ArticleSection = {
  type: 'intro' | 'h2' | 'h3' | 'paragraph' | 'table' | 'checklist' | 'cta';
  title?: string;
  content?: string;
  items?: string[];
  tableRows?: { cells: string[] }[];
  tableHeaders?: string[];
};

export const articles: ArticleData[] = [
  {
    slug: 'guia-cssbuy-spreadsheet-2026',
    title: 'CSSBuy Spreadsheet: O Guia Definitivo para Importar da China em 2026',
    description: 'Guia completo sobre a planilha CSSBuy: como funciona, como acessar e como economizar nas suas importações da China em 2026.',
    date: 'Junho 2026',
    readTime: '12 min',
    imageSeq: 'article-img-guia-01',
    imageQuery: 'Professional%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20on%20warm%20cream%20desk%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20warm%20neutral%20tones%2C%20clean%20composition%2C%20modern%20office%20photography',
    keywords: 'cssbuy spreadsheet, guia cssbuy, planilha cssbuy, importar da china, agentes compras china',
    sections: [],
  },
  {
    slug: 'cssbuy-vs-pandabuy-spreadsheet',
    title: 'CSSBuy vs Pandabuy: Comparação Completa de Planilhas e Preços 2026',
    description: 'Análise detalhada comparando CSSBuy e Pandabuy: taxas, preços de produtos, qualidade de serviço e qual planilha oferece as melhores oportunidades de importação.',
    date: 'Junho 2026',
    readTime: '10 min',
    imageSeq: 'article-img-compare-01',
    imageQuery: 'Side%20by%20side%20comparison%20concept%20with%20two%20modern%20smartphones%20on%20warm%20beige%20surface%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20clean%20composition%2C%20neutral%20background%2C%20tech%20product%20photography',
    keywords: 'cssbuy vs pandabuy, comparacao agentes china, planilha comparativa, importacao china',
    sections: [],
  },
  {
    slug: 'melhores-sneakers-cssbuy-spreadsheet',
    title: 'Melhores Sneakers na Planilha CSSBuy: Lista Atualizada 2026',
    description: 'Descubra os tênis mais populares e bem avaliados na planilha CSSBuy. Lista atualizada diariamente com scores de qualidade e análise de risco para cada modelo.',
    date: 'Junho 2026',
    readTime: '8 min',
    imageSeq: 'article-img-sneakers-01',
    imageQuery: 'Stylish%20designer%20sneakers%20arranged%20on%20light%20cream%20surface%20with%20warm%20natural%20lighting%2C%20minimal%20editorial%20composition%2C%20clean%20product%20photography%2C%20soft%20shadows%2C%20warm%20neutral%20background%2C%20elevated%20fashion%20display',
    keywords: 'melhores sneakers cssbuy, tenis planilha cssbuy, sneakers china, cssbuy spreadsheet sneakers',
    sections: [],
  },
  {
    slug: 'como-economizar-cssbuy-spreadsheet',
    title: 'Como a Planilha CSSBuy Ajuda Você a Economizar nas Importações',
    description: 'Estratégias práticas para reduzir custos de importação usando a planilha CSSBuy. Dicas de comparação de preços, escolha de agentes e otimização de envio.',
    date: 'Junho 2026',
    readTime: '9 min',
    imageSeq: 'article-img-save-01',
    imageQuery: 'Stack%20of%20euro%20coins%20and%20a%20notebook%20with%20calculations%20on%20warm%20cream%20desk%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20clean%20composition%2C%20warm%20neutral%20background%2C%20financial%20savings%20concept%20photography',
    keywords: 'economizar cssbuy, planilha cssbuy economia, importar barato china, dicas importacao',
    sections: [],
  },
  {
    slug: 'top-produtos-cssbuy-spreadsheet',
    title: 'Top 100 Produtos na Planilha CSSBuy: Os Mais Populares de 2026',
    description: 'Os 100 produtos mais acessados e comprados através da planilha CSSBuy. De streetwear a acessórios de luxo, veja o ranking completo atualizado.',
    date: 'Junho 2026',
    readTime: '11 min',
    imageSeq: 'article-img-top-01',
    imageQuery: 'Collection%20of%20popular%20fashion%20items%20including%20hoodie%20sneakers%20and%20bag%20arranged%20on%20warm%20cream%20surface%2C%20minimal%20editorial%20composition%2C%20soft%20natural%20light%2C%20clean%20product%20photography%2C%20neutral%20background',
    keywords: 'top produtos cssbuy, melhores produtos china, planilha cssbuy top, importacao produtos populares',
    sections: [],
  },
  {
    slug: 'streetwear-cssbuy-spreadsheet',
    title: 'Streetwear na Planilha CSSBuy: Supreme, Trapstar, Essentials e Mais',
    description: 'Guia completo de streetwear disponível na planilha CSSBuy. Marcas como Supreme, Trapstar, Essentials e Gallery Dept analisadas com preços e scores.',
    date: 'Junho 2026',
    readTime: '9 min',
    imageSeq: 'article-img-street-01',
    imageQuery: 'Streetwear%20hoodie%20and%20cap%20laid%20flat%20on%20warm%20cement%20texture%20background%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20clean%20urban%20fashion%20composition%2C%20neutral%20tones%2C%20contemporary%20photography',
    keywords: 'streetwear cssbuy, supreme planilha, trapstar cssbuy, essentials importacao',
    sections: [],
  },
  {
    slug: 'guia-envio-cssbuy-europa',
    title: 'Guia de Envio CSSBuy para Europa: Prazos, Custos e Dicas 2026',
    description: 'Tudo sobre opções de envio da China para Europa usando CSSBuy. Compare transportadoras, prazos de entrega e custos para cada país europeu.',
    date: 'Junho 2026',
    readTime: '8 min',
    imageSeq: 'article-img-shipping-01',
    imageQuery: 'Cardboard%20shipping%20box%20with%20shipping%20labels%20on%20warm%20cream%20desk%20next%20to%20world%20map%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20clean%20composition%2C%20warm%20neutral%20background%2C%20logistics%20photography',
    keywords: 'envio cssbuy europa, frete china europa, shipping cssbuy, importacao europa china',
    sections: [],
  },
  {
    slug: 'cssbuy-e-seguro-analise',
    title: 'CSSBuy é Seguro? Análise Completa de Riscos e Proteções 2026',
    description: 'Análise honesta sobre a segurança de usar CSSBuy para importar da China. Riscos comuns, como se proteger e por que a planilha reduz os perigos.',
    date: 'Junho 2026',
    readTime: '10 min',
    imageSeq: 'article-img-safe-01',
    imageQuery: 'Shield%20symbol%20made%20of%20frosted%20glass%20on%20warm%20cream%20minimal%20surface%2C%20soft%20natural%20light%2C%20clean%20editorial%20composition%2C%20security%20concept%2C%20warm%20neutral%20background%2C%20elegant%20minimal%20photography',
    keywords: 'cssbuy seguro, cssbuy confiavel, analise risco cssbuy, protecao importacao china',
    sections: [],
  },
  {
    slug: 'agentes-china-comparacao-cssbuy',
    title: 'Comparação de Agentes da China: CSSBuy, Pandabuy, Sugargoo e Mais',
    description: 'Tabela comparativa completa dos principais agentes de compras da China. Taxas, velocidades de envio, qualidade de serviço e suporte ao cliente.',
    date: 'Junho 2026',
    readTime: '11 min',
    imageSeq: 'article-img-agents-01',
    imageQuery: 'Multiple%20smartphones%20displaying%20different%20shopping%20interfaces%20on%20warm%20cream%20surface%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20clean%20tech%20composition%2C%20neutral%20background%2C%20comparison%20concept%20photography',
    keywords: 'comparacao agentes china, cssbuy vs sugargoo, melhores agentes china, planilha agentes importacao',
    sections: [],
  },
  {
    slug: 'erros-comuns-cssbuy-spreadsheet',
    title: '7 Erros Comuns ao Usar a Planilha CSSBuy e Como Evitá-los',
    description: 'Os erros mais frequentes que compradores cometem ao usar a planilha CSSBuy e dicas práticas para maximizar suas economias e evitar problemas.',
    date: 'Junho 2026',
    readTime: '7 min',
    imageSeq: 'article-img-errors-01',
    imageQuery: 'Magnifying%20glass%20over%20a%20notebook%20with%20red%20marks%20on%20warm%20cream%20desk%2C%20minimal%20editorial%20style%2C%20soft%20natural%20light%2C%20clean%20composition%2C%20warm%20neutral%20background%2C%20error%20analysis%20concept%20photography',
    keywords: 'erros cssbuy spreadsheet, dicas cssbuy, problemas importacao china, como usar planilha cssbuy',
    sections: [],
  },
];